
export const VARIABLES = {
  title: '--select--',
};

export const GSC_API_PATH = 'https://accounts.google.com/gsi/client';

// file uploading

export const FILE_UPLOAD_VARIABLES = {
  nameOfFile: 'Drag and drop',
};
// Months
export const months = [
  'Jan', 'Feb', 'Mar', 'Apr',
  'May', 'June', 'July', 'Aug',
  'Sept', 'Oct', 'Nov', 'Dec'
];

// Methods

export const REQUEST = {
  GET: 'GET',
  POST: 'POST',
  PATCH: 'PATCH',
  DELETE: 'DELETE',
};

export const TABLE_VARIABLES = {
  AssetTag: 'Asset Tag',
  ticketDate: 'Ticket Date',
  assetName: 'Asset Name',
  status: 'Status',
  ticketRaisedBy: 'Ticket raised by',
};

export const BOOLEAN = {
  true: true,
  false: false,
};

export const ASSET_TYPES = [
  {
    assetId: '141d6a2a-e61d-49a2-a8de-25806d2b2bc9',
    assetName: 'Monitor',
    assetCode: 'M',
  },
  {
    assetId: '6d88b333-4b4d-4d86-b5fe-b6f8f1ec131d',
    assetName: 'Laptop',
    assetCode: 'L',
  },
  {
    assetId: '314b8915-f098-4d87-b7ce-3d951b059002',
    assetName: 'Keyboard',
    assetCode: 'KB',
  },
  {
    assetId: 'f53b05b9-1f90-4625-84d9-75b11a567b47',
    assetName: 'Mouse',
    assetCode: 'MS',
  },
  {
    assetId: 'def3219a-237e-44ca-acde-5ad8014e0e6d',
    assetName: 'Charger',
    assetCode: 'C',
  },
  {
    assetId: '9510fbca-2848-490d-b49c-6dce938d8ebd',
    assetName: 'C Type Connector',
    assetCode: 'CTC',
  },
  {
    assetId: '8a976df6-e72a-4dfe-a27a-67fb82f8034a',
    assetName: 'Mobile Phone',
    assetCode: 'MB',
  },
  {
    assetId: '59ee6611-1558-4593-9bd2-d7dad584c10f',
    assetName: 'Headphone',
    assetCode: 'H',
  },
];

export const WARRANTY_TENURE = [
  '90 Days',
  '180 Days',
  '270 Days',
  '360 Days',
  '450 Days',
  '540 Days',
];

export const SPECIFICATIONS = {
  Laptop: [
    {
      fieldName: 'Model Name',
      fieldType: 'text',
    },
    {
      fieldName: 'Processor',
      fieldType: 'dropdown',
    },
    {
      fieldName: 'Operating System',
      fieldType: 'dropdown',
    },
  ],
  Headphone: [
    {
      fieldName: 'Model Name',
      fieldType: 'text',
    },
    {
      fieldName: 'Serial Number',
      fieldType: 'number',
    },
  ],
  Keyboard: [
    {
      fieldName: 'Model Name',
      fieldType: 'text',
    },
  ],
  'Mobile Phone': [
    {
      fieldName: 'Model Name',
      fieldType: 'text',
    },
    {
      fieldName: 'Serial Number',
      fieldType: 'number',
    },
  ],
  Monitor: [
    {
      fieldName: 'Model Name',
      fieldType: 'text',
    },
    {
      fieldName: 'Screem Size',
      fieldType: 'number',
    },
  ],
  Mouse: [
    {
      fieldName: 'Model Name',
      fieldType: 'text',
    },
  ],
  'C Type Connector': [
    {
      fieldName: 'Model Name',
      fieldType: 'text',
    },
    {
      fieldName: 'Serial Number',
      fieldType: 'number',
    },
  ]
};

export const FILTER = {
  todo: 'to-do',
  onhold: 'on-hold',
  closed: 'closed',
  all: 'all',
  ongoing: 'ongoing',
  pending: 'pending',
  assigned: 'assigned',
};

export const SIDENAV = {
  dashboard: 'dashboard',
  inventory: 'inventory',
  tickets: 'tickets',
  bulkUpload: 'bulk upload',
  ManageWorkSpace: 'manage workspace',
  info: 'info',
};

export const TEMPLATE_LIST_TYPES = {
  BULK_ADD_ASSETS: "bulkAddAssets",
  BULK_UPDATE_ASSETS: "bulkUpdateAssets",
  BULK_ASSET_OUT_FOR_REPAIR: "bulkAssetOutForRepair",
  BULK_MARK_ASSET_AS_EWASTE: "bulkMarkAssetAsEwaste",
  BULK_ASSET_ALLOCATION: "bulkAssetAllocation"
};

export const UPLOAD_LIST_TYPES = [
  { id: 'asset_list', title: 'Asset list' },
  { id: 'asset_allocation_list', title: 'Asset allocation list' },
  { id: 'asset_out_for_repair', title: 'Asset out for repair' },
  { id: 'asset_list_update', title: 'Asset list - Update' },
  { id: 'mark_asset_ewaste', title: 'Asset list mark as e-waste' },
  { id: 'user_list', title: 'User list' },
];

export const DOWNLOAD_LIST_OPTIONS = [
  { id: 'user_list', title: 'User list', fileType: 'all' },
  { id: 'asset_list', title: 'Asset list', fileType: 'all' },
  {
    id: 'asset_allocation_list',
    title: 'Asset allocation list',
    fileType: 'all',
  },
  {
    id: 'asset_out_for_repair',
    title: 'Asset out for repair list',
    fileType: 'template_file',
  },
  {
    id: 'asset_update_list',
    title: 'Asset update list',
    fileType: 'template_file',
  },
  {
    id: 'mark_asset_e_waste',
    title: 'Asset list mark as e-waste',
    fileType: 'template_file',
  },
];

export const DOWNLOAD_LIST_TYPES = [
  { id: 'template_file', title: 'Template File' },
  { id: 'database_file', title: 'Database File' },
];


export const G_AUTH_TOKEN =
  '874163583758-u3f0rdgpdlqsirp6ajsvm61bpc2d7bh7.apps.googleusercontent.com';

export enum TICKET_STATUS {
  PENDING = 'TO_DO',
  ASSIGNED = 'ONGOING',
  CLOSED = 'CLOSED',
  EXTERNAL = 'EXTERNAL',
  ALL = 'ALL',
  ON_HOLD = 'ON_HOLD'

}

export enum REQUEST_STATUS {
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
  PENDING = 'PENDING',
  ALL = 'ALL'
}
export const BUTTON_TEXT = {
  SAVE: 'Save',
  ADD: 'Add',
  UPDATE: 'Update'
};

export const ASSET_STATUS = {
  AVAILABLE: 'AVAILABLE',
  DAMAGED: 'DAMAGED',
  OUT_FOR_REPAIR: 'OUT_FOR_REPAIR',
  IN_HOUSE_REPAIR: 'IN_HOUSE_REPAIR',
  ALLOCATED: 'ALLOCATED',
  DISABLED: 'DISABLED',
  NOT_IN_USE: 'NOT_IN_USE',
  MARK_AS_EWASTE: 'MARKED_AS_E_WASTE',
  ALL: 'ALL',
  REPAIR: 'REPAIR',
};

export const MANAGE_WORKSPACE = {
  ACTIVE: 'ACTIVE',
  UPCOMING: 'UPCOMING',
  IN_ACTIVE: 'IN_ACTIVE',
  ALL: 'ALL',
};

export const CREATE_WORKSPACE = {
  ACTIVE: 'ACTIVE',
  IN_ACTIVE: 'IN_ACTIVE',
  ALL: 'ALL'
}

export const TRANSACTION_STATUS = {
  CHECKIN: "CheckIn",
  CHECKIN_OUT_FOR_REPAIR: "CheckIn Out For Repair",
  CHECKOUT_OUT_FOR_REPAIR: "CheckOut Out For Repair",
  CHECKOUT: "CheckOut",
  CHECKIN_IN_HOUSE_REPAIR: "CheckIn In House Repair",
  CHECKOUT_IN_HOUSE_REPAIR: "CheckOut In House Repair",
  CHECKOUT_NOT_IN_USE: "CheckOut Not In Use",
  CHECKIN_NOT_IN_USE: "CheckIn Not In Use",
  CHECKOUT_E_WASTE: "CheckOut E Waste",
};

export const HISTORY_TRANSACTION_STATUS = {
  CHECKOUT_OUT_FOR_REPAIR: "CHECKOUT_OUT_FOR_REPAIR",
  CHECKIN_OUT_FOR_REPAIR: "CHECKIN_OUT_FOR_REPAIR",
  CHECKOUT_USER: "CHECKOUT_USER",
  CHECKIN_USER: "CHECKIN_USER",
  CHECKOUT_IN_HOUSE_REPAIR: "CHECKOUT_IN_HOUSE_REPAIR",
  CHECKIN_IN_HOUSE_REPAIR: "CHECKIN_IN_HOUSE_REPAIR",
  TRANSACTION_REASON: "TRANSACTION_REASON",
  CHECKOUT_NOT_IN_USE: "CHECKOUT_NOT_IN_USE",
  CHECKIN_NOT_IN_USE: "CHECKIN_NOT_IN_USE",
  CHECKOUT_E_WASTE: "CHECKOUT_E_WASTE",
};
export const HISTORY_HEADER_TITLES = {
  LOANEE: 'Loanee',
  OUT_FOR_REPAIR: 'Out for Repair',
  IN_HOUSE_REPAIR: 'In-house Repair',
  CHECKOUT_E_WASTE: 'E-Waste',
  CHECKOUT_NOT_IN_USE: 'Not In Use',
  CHECKIN_OUT_FOR_REPAIR: 'Out for Repair'
}
export const HISTORY_TYPES = {
  LOANEE_HISTORY: "Loanee History",
  REPAIR_HISTORY: "Repair History",
  ALL_HISTORY: "All History"
}
export const TICKETS_MENU = [
  {
    title: 'To-Do',
    count: 0,
    route: '/home/admin-ticket/coditas',
    status: TICKET_STATUS.PENDING,
  },
  {
    title: 'Ongoing',
    count: 0,
    route: '/home/admin-ticket/coditas',
    status: TICKET_STATUS.ASSIGNED,
  },
  {
    title: 'On-Hold',
    count: 0,
    route: '/home/admin-ticket/coditas',
    status: TICKET_STATUS.ON_HOLD,
  },
  {
    title: 'Closed',
    count: 0,
    route: '/home/admin-ticket/coditas',
    status: TICKET_STATUS.CLOSED,
  },
  {
    title: 'External',
    count: 0,
    route: '/home/admin-ticket/coditas',
    status: TICKET_STATUS.EXTERNAL,
  },
  {
    title: 'All',
    count: 0,
    route: '/home/admin-ticket/coditas',
    status: TICKET_STATUS.ALL,
  },
];

export const REQUEST_MENU = [
  {
    title: 'Approved',
    count: 0,
    route: '/home/admin-approval/coditas',
    status: REQUEST_STATUS.APPROVED,
  },
  {
    title: 'Declined',
    count: 0,
    route: '/home/admin-approval/coditas',
    status: REQUEST_STATUS.DECLINED,
  },
  {
    title: 'Pending',
    count: 0,
    route: '/home/admin-approval/coditas',
    status: REQUEST_STATUS.PENDING,
  },
  {
    title: 'All',
    count: 0,
    route: '/home/admin-approval/coditas',
    status: REQUEST_STATUS.ALL,
  },
];

export const ASSETS_MENU = [
  {
    title: 'Assigned',
    count: '1',
    route: '../inventory',
    status: ASSET_STATUS.ALLOCATED,
  },
  {
    title: 'Available',
    count: '2',
    route: '../inventory',
    status: ASSET_STATUS.AVAILABLE,
  },
  {
    title: 'Out for Repair',
    count: '3',
    route: '../inventory',
    status: ASSET_STATUS.OUT_FOR_REPAIR,
  },
  {
    title: 'In House Repair',
    count: '4',
    route: '../inventory',
    status: ASSET_STATUS.IN_HOUSE_REPAIR,
  },
  {
    title: 'Disabled',
    count: '5',
    route: '../inventory',
    status: ASSET_STATUS.DISABLED,
  },
  {
    title: 'All',
    count: '6',
    route: '../inventory',
    status: ASSET_STATUS.ALL,
  },
];
export const WORKSPACE_MENU = [
  {
    title: 'Inactive',
    count: '1',
    route: '../manage-workspace',
    status: CREATE_WORKSPACE.ACTIVE
  },
  {
    title: 'Active',
    count: '2',
    route: '../manage-workspace',
    status: CREATE_WORKSPACE.IN_ACTIVE
  },
  {
    title: 'All',
    count: '3',
    route: CREATE_WORKSPACE.ALL
  }

];

export const TICKET_SEARCH_OPTIONS = [
  { title: 'Ticket No.', value: 'TICKET_NUMBER' },
  { title: 'Ticket Date', value: 'TICKET_DATE' },
  { title: 'Asset Name', value: 'ASSET_NAME' },
  { title: 'Raised By', value: 'TICKET_RAISED_BY' },
  { title: 'Assigned to', value: 'ASSIGNED_TO' },
];
export const PROJECT_SEARCH_OPTIONS = [
  { title: 'Project Name', value: 'PROJECT_NAME' },
  {title: 'Client Name', value: 'CLIENT_NAME'}
]
export const REQUEST_SEARCH_OPTIONS = [
  { title: 'Ticket No.', value: 'TICKET_NUMBER' },
  { title: 'Ticket Date', value: 'TICKET_DATE' },
  { title: 'Asset Name', value: 'ASSET_NAME' },
  { title: 'Raised By', value: 'TICKET_RAISED_BY' },
  { title: 'Assigned to', value: 'TICKET_ASSIGNED_TO' }
];
export const WORKSPACE_SEARCH_OPTIONS = [
  { title: 'Workspace Name', value: 'WORKSPACE_NAME' },
];

export const ASSET_SEARCH_OPTIONS = [
  { title: 'Asset Code', value: 'ASSET_CODE' },
  { title: 'Asset Name', value: 'ASSET_NAME' },
  { title: 'Loanee', value: 'LOANEE' },
];

export const ASSET_SORT_COLUMNS = {
  ASSET_CODE: 'ASSET_CODE',
  ASSET_LOCATION: 'ASSET_LOCATION',
  ASSET_NAME: 'ASSET_NAME',
  STATUS: 'STATUS',
  LOAN_STATUS: 'LOAN_STATUS',
  LOANEE: 'LOANEE',
  ASSIGNED_TO: 'ASSIGNED_TO',
  ONBOARDING_DATE: 'ONBOARDING_DATE',
};

export const TICKET_SORT_COLUMNS = {
  ASSET_NAME: 'ASSET_NAME',
  PRIORITY: 'PRIORITY',
  TICKET_NUMBER: 'TICKET_NUMBER',
  TICKET_DATE: 'TICKET_DATE',
  ASSET_CODE: 'ASSET_CODE',
  TICKET_STATUS: 'TICKET_STATUS',
  TICKET_RAISED_BY: 'TICKET_RAISED_BY',
  ASSIGNED_TO: 'ASSIGNED_TO',
  STATUS: 'TICKET_STATUS'
};
export const PROJECT_SORT_COLUMNS = {
  CLIENT_NAME: 'CLIENT_NAME',
  PROJECT_NAME: 'PROJECT_NAME',
  CREATED_BY: 'CREATED_BY',
  CREATED_ON: 'CREATED_AT',
  ASSETS_LINKED: 'ASSETS_LINKED'
};
export const VENDOR_SORT_COLUMNS = {
  VENDOR_NAME: 'name',
  VENDOR_EMAIL: 'email',
  VENDOR_PHONE_NUMBER: 'phoneNumber'
}
export const REQUEST_SORT_COLUMNS = {
  ASSET_NAME: 'ASSET_NAME',
  PRIORITY: 'PRIORITY',
  TICKET_NUMBER: 'TICKET_NUMBER',
  TICKET_DATE: 'TICKET_DATE',
  ASSET_CODE: 'ASSET_CODE',
  REQUEST_STATUS: 'REQUEST_STATUS',
  REQUEST_RAISED_BY: 'REQUEST_RAISED_BY',
  ASSIGNED_TO: 'ASSIGNED_TO',
};
export const WORKSPACE_SORT_COLUMN = {
  WORKSPACE_NAME: 'WORKSPACE_NAME',
  PLAN_NAME: 'PLAN_NAME',
  START_DATE: 'PLAN_ACTIVE_FROM',
  END_DATE: 'PLAN_ACTIVE_TO'
}
export const APPROVAL_SORTING_COLUMN = {
  TICKET_NUMBER: "TICKET_NUMBER",
  TICKET_DATE: "TICKET_DATE",
  TICKET_RAISED_BY: "TICKET_RAISED_BY",
  TICKET_ASSIGNED_TO: "TICKET_ASSIGNED_TO",
  ASSET_NAME: "ASSET_NAME",
  TICKET_STATUS: "TICKET_STATUS",
  APPROVAL_STATUS: "APPROVAL_STATUS",
};
export const CLIENT_SORTING_COLUMN = { 
  CLIENT_NAME: "CLIENT_NAME",
  CREATED_AT: "CREATED_AT", 
  CREATED_BY: "CREATED_BY", 
}; 
export const CLIENT_SEARCH_OPTIONS = [
  { title: 'Client Name', value: 'CLIENT_NAME' },
  { title: 'Added By', value: 'CREATED_BY' }
];
export const VENDOR_SEARCH_OPTIONS = [
  {title: 'Vendor Name', value: 'VENDOR_NAME'},
  {title: 'Vendor Email', value: 'VENDOR_EMAIL'},
  {title: 'Vendor Phone Number', value: 'VENDOR_PHONE_NUMBER'}
]
export const PAGINATION_DATA = [
  { title: '5', value: '5' },
  { title: '10', value: '10' },
  { title: '15', value: '15' },
];

export const TICKET_TYPES = {
  ASSET_ALLOCATION: 'ALLOCATION',
  REPAIR_OR_REPLACEMENT: 'REPAIR/REPLACEMENT',
  ACCESS_INSTALLATION: 'ACCESS/INSTALLATION'
};

export const ASSET_LOCATIONS = [
  'Nyati',
  'Bhairav Estate',
  'Gaia Apex',
  'Remote',
];

export enum TICKET_STATES {
  SUCCESS = 'SUCCESS',
  DEFAULT = 'DEFAULT',
  ERROR = 'ERROR',
}

export enum APPROVAL_STATUS {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  DECLINED = 'DECLINED',
}

export enum CUSTODY_VERIFICATION_STATUS {
  VERIFIED = 'VERIFIED',
  NOT_VERIFIED = 'NOT_VERIFIED',
  PENDING = 'PENDING',
}

export const ASSET_STATUS_OPTIONS = [
  {
    assetStatus: 'Mark as Disabled',
    assetValue: 'DISABLED',
  },
  {
    assetStatus: 'Discard as e-waste',
    assetValue: 'DISABLED',
  },
];

export const TICKET_PRIORITIES = {
  HIGH: 'High',
  MEDIUM: 'Medium',
  LOW: 'Low',
};

export const ASSET_INFO_HEADINGDS = {
  TICKET_STATUS: 'Ticket Status',
  ASSET_STATUS: 'Asset Status',
  APPROVAL_STATUS: 'Approval Status'
};

export const PROGRESS_STATUS = {
  FAILED: 'fail',
  SUCCESS: 'success',
  NONE: 'none',
};

export const EKO_TICKET_STATUS = [
  {
    title: 'To-Do',
    count: 0,
    route: '/home/admin-ticket/coditas',
    status: TICKET_STATUS.PENDING,
  },
  {
    title: 'Ongoing',
    count: 0,
    route: '/home/admin-ticket/coditas',
    status: TICKET_STATUS.ASSIGNED,
  },
  {
    title: 'Closed',
    count: 0,
    route: '/home/admin-ticket/coditas',
    status: TICKET_STATUS.CLOSED,
  },
  {
    title: 'All',
    count: 0,
    route: '/home/admin-ticket/coditas',
    status: TICKET_STATUS.ALL,
  },
]

export const EKO_ASSET_STATUS = [
  {
    title: 'Available',
    count: '2',
    route: '../inventory',
    status: ASSET_STATUS.AVAILABLE,
  },
  {
    title: 'Assigned',
    count: '1',
    route: '../inventory',
    status: ASSET_STATUS.ALLOCATED,
  },

  {
    title: 'Repair',
    count: '3',
    route: '../inventory',
    status: ASSET_STATUS.REPAIR,
  },
  {
    title: 'Disabled',
    count: '4',
    route: '../inventory',
    status: ASSET_STATUS.DISABLED,
  },
  {
    title: 'All',
    count: '5',
    route: '../inventory',
    status: ASSET_STATUS.ALL,
  },
];

export const MODALS = {
  ASSIGNEE_CONFIRMATION_POPUP: 'assignee-confirmation-popup',
  ASSIGNEE_CONFIRMATION_POPUP_FIRST_TIME: 'assignee-confirmation-popup-for-first-time',
  CHECKOUT_CONFIRMATION_POPUP: 'checkout-confirmation-popup',
  DUPLICATE_ASSET_POPUP: 'duplicate-asset-popup',
  CHECKOUT_SUCCESS_CONFIRMATION_POPUP: 'checkout-success-confirmation-popup',
  CHECKIN_CONFIRMATION_POPUP: 'checkin-confirmation-popup',
  CHECKIN_SUCCESS_CONFIRMATION_POPUP: 'checkin-success-confirmation-popup',
  RESEND_APPROVAL_CONFIRMATION: 'resend-approval-confirmation',
  REQUEST_APPROVAL_CONFIRMATION: 'request-approval-confirmation',
  RAISE_TICKET_MODAL: 'raise-ticket-modal',
  REQUEST_ASSET_MODAL: 'request-asset-modal',
  ACCESS_INSTALLATION_MODAL: 'access-installation-modal',
  OUT_FOR_REPAIR_MODAL: 'out-for-repair-modal',
  CHECKOUT_FOR_REPAIR_SUCCESSFULL: 'checkout-for-repair-successfull',
}
export const STORE_RUNTIME_CHECKS = {
  strictStateImmutability: true,
  strictActionImmutability: true,
  strictStateSerializability: true,
  strictActionSerializability: true,
};
export type ApprovalStatus = 'DECLINED' | 'PENDING' | 'APPROVED' | 'ALL';
export const APPROVAL_PLACEHOLDERS = {
  DECLINED: {
    title: 'No Declined Approvals',
    subtitle: 'There are no declined approvals',
  },
  PENDING: {
    title: 'No Pending Approvals',
    subtitle: 'There are no pending approvals',
  },
  APPROVED: {
    title: 'No Approved Approvals',
    subtitle: 'There are no approved approvals',
  },
  ALL: {
    title: 'No Approvals',
    subtitle: 'There are no approvals to show',
  },
  DEFAULT: {
    title: 'No Approvals',
    subtitle: 'There are no approvals to show',
  }
};
export type TicketStatus = 'CLOSED' | 'TO_DO' | 'ONGOING' | 'ON_HOLD' | 'EXTERNAL' | 'ALL';
export type AssetStatus = 'ALLOCATED' | 'AVAILABLE' | 'DISABLED' | 'OUT_FOR_REPAIR' | 'ALL';
export const TICKET_PLACEHOLDERS = {
  CLOSED: { title: 'No Closed Tickets', subtitle: 'There are no closed tickets' },
  TO_DO: { title: 'No To-DO Tickets', subtitle: 'There are no To-Do tickets' },
  ONGOING: { title: 'No Ongoing Tickets', subtitle: 'There are no ongoing tickets' },
  ON_HOLD: { title: 'No On-HOLD Tickets', subtitle: 'There are no On-Hold tickets' },
  EXTERNAL: { title: 'No External Tickets', subtitle: 'There are no external tickets' },
  ALL: { title: 'No tickets generated yet', subtitle: 'Once you start generating tickets, they will appear here' },
  DEFAULT: { title: 'No tickets generated yet', subtitle: 'Once you start generating tickets, they will appear here' },
};
export const ASSET_PLACEHOLDERS = {
  ALLOCATED: { title: 'No Assigned Assets', subtitle: 'There are no assinged assets' },
  AVAILABLE: { title: 'No Available Assets', subtitle: 'There are no available assets' },
  DISABLED: { title: 'No Disabled Assets', subtitle: 'There are no disabled assets' },
  OUT_FOR_REPAIR: { title: 'No Out-for-repair Assets', subtitle: 'There are no out for repair Assets' },
  ALL: { title: 'No Assets', subtitle: 'There are no assets to show' },
  DEFAULT: { title: 'No Assets', subtitle: 'There are no assets to show' },
};
export const Ticket_Statuses = {
  CLOSED: { status: 'Completed' },
  TO_DO: { status: 'To-Do' },
  ONGOING: { status: 'Ongoing' },
  ON_HOLD: { status: 'On-Hold' },
  DEFAULT: { status: '' }
};
export const workspaceFieldsMap: Record<string, string> = {
  workspaceName: 'workspaceName',
  acronymLength: 'acronymLength',
  initialAssetNumber: 'initialAssetNumber',
  establishmentDate: 'establishmentDate',
  companyName: 'companyName',
  companyWebsiteLink: 'companyWebsiteLink',
};
export const ownerFieldsMap: Record<string, string> = {
  firstName: 'firstName',
  lastName: 'lastName',
  empId: 'empId',
  password: 'password',
  email: 'email',
  phoneNumber: 'phoneNumber',
};
export const editWorkspace = {
  workspaceDetails: 'workspaceDetails',
  userAttributes: 'userAttributes',
  workspaceOwnerDetails: 'workspaceOwnerDetails',
  plan: 'plan'
}
export const planFields: Record<string, string> = {
  planName: 'planName',
  numWorkspaceOwners: 'numWorkspaceOwners',
  numEndUsers: 'numEndUsers',
  numItAdmins: 'numItAdmins',
  numOfAssets: 'numOfAssets',
  planFee: 'planFee',
  planDuration: 'planDuration'
}
export const planDurationList = [
  { id: 1, name: '6 months', days: 180 },
  { id: 2, name: '1 year', days: 365 },
  { id: 3, name: '1 year 6 months', days: 547 },
  { id: 4, name: '2 years', days: 730 },
  { id: 5, name: '2 years 6 months', days: 912 },
  { id: 6, name: '3 years', days: 1095 },
  { id: 7, name: '2 years 11 months', days: 1065 }
];
export const CHART_COLORS = {
  background: ['#007243','#D81B60','#F4B400', '#2196f3', '#EF3E36'],
  hoverBackground: ['#005627','#ac154cff', '#c79b00','#166bb0ff','#b3312b'],
  subscriptionBackground: ['#007243', '#EF3E36', '#F4B400', '#2196f3'],
  subscriptionHover: ['#005627', '#b3312b', '#c79b00', '#166bb0ff'],
};
export const SEARCH_BY = {
  VENDOR_NAME: 'VENDOR_NAME',
  VENDOR_EMAIL: 'VENDOR_EMAIL',
  VENDOR_PHONE_NUMBER: 'VENDOR_PHONE_NUMBER'
} as const;
export type SearchBy = typeof SEARCH_BY[keyof typeof SEARCH_BY];
export const PLACEHOLDERS: Record<SearchBy, string> = {
  [SEARCH_BY.VENDOR_NAME]: 'Search by vendor name (Eg - John Doe)',
  [SEARCH_BY.VENDOR_EMAIL]: 'Search by vendor email (Eg - john@gmail.com)',
  [SEARCH_BY.VENDOR_PHONE_NUMBER]: 'Search by vendor phone number (Eg - 2768777277)'
};

export const CLIENT_SEARCH_BY = {
  CLIENT_NAME: 'CLIENT_NAME',
  CREATED_BY: 'CREATED_BY'
} as const;
export type ClientSearchBy = typeof CLIENT_SEARCH_BY[keyof typeof CLIENT_SEARCH_BY];
export const CLIENT_PLACEHOLDERS: Record<ClientSearchBy, string> = {
  [CLIENT_SEARCH_BY.CLIENT_NAME]: 'Search by client name (Eg - John Doe)',
  [CLIENT_SEARCH_BY.CREATED_BY]: 'Search by added by (Eg - Admin, Manager)'
};
export const SEARCH_FILTERS = {
  TICKET_NUMBER: 'TICKET_NUMBER',
  TICKET_DATE: 'TICKET_DATE',
  ASSET_NAME: 'ASSET_NAME',
  ASSET_CODE: 'ASSET_CODE',
  LOANEE: 'LOANEE',
  TICKET_ASSIGNED_TO: 'TICKET_ASSIGNED_TO',
  TICKET_RAISED_BY: 'TICKET_RAISED_BY',
  WORKSPACE_NAME: 'WORKSPACE_NAME',
  WORKSPACE_STATUS: 'WORKSPACE_STATUS',
  ASSIGNED_TO: 'ASSIGNED_TO',
  DEFAULT: 'DEFAULT',
  CLIENT_NAME: 'CLIENT_TIME',
  CREATED_BY: 'CREATED_BY',
  PROJECT_NAME: 'PROJECT_NAME'
} as const;

export type SearchFilter = keyof typeof SEARCH_FILTERS;

export const TICKETS_PLACEHOLDERS: Record<SearchFilter, string> = {
  TICKET_NUMBER: "Enter the ticket number (Eg - 2923)",
  TICKET_DATE: "Enter the ticket date (Eg - 19/09)",
  ASSET_NAME: "Enter the asset name (Eg - Laptop)",
  ASSET_CODE: "Enter the asset code (Eg - CSL-L-19-20-L-0002)",
  LOANEE: "Enter the loanee's name (Eg - John Doe)",
  TICKET_ASSIGNED_TO: "Enter the assignee's name (Eg - John Doe)",
  TICKET_RAISED_BY: "Enter the name (Eg - John Doe)",
  WORKSPACE_NAME: "Enter the workspace name",
  WORKSPACE_STATUS: "Enter the workspace status",
  ASSIGNED_TO: "Enter the assignee's name (Eg - John Doe)",
  DEFAULT: "Select an option to start searching",
  CLIENT_NAME: 'Enter the name of client (Eg - John Doe)',
  CREATED_BY: 'Enter the name (Eg - John Doe)',
  PROJECT_NAME: 'Enter the name of project'
};
export const EMPLOYEE_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive'
}
